import Loadable from "@loadable/component";

import {
  AppBarLoader,
  ImageCarouselLoader,
  Loader,
  MobileRestaurantInfoLoader,
  TabsLoader,
} from "./Loaders";

export const Overview = Loadable(
  () =>
    import(
      /* webpackChunkName: "RestaurantOverviewPage" */ "pages/restaurant/overview"
    ),
  { fallback: <Loader /> }
);
export const Events = Loadable(
  () =>
    import(
      /* webpackChunkName: "RestaurantEventsPage" */ "pages/restaurant/events"
    ),
  { fallback: <Loader /> }
);

export const Order = Loadable(
  () =>
    import(
      /* webpackChunkName: "RestaurantOrderPage" */ "pages/restaurant/order"
    ),
  { fallback: <Loader /> }
);
export const OrderSidebar = Loadable(
  () =>
    import(
      /* webpackChunkName: "RestaurantOrderSidebarPage" */ "pages/restaurant/order/Sidebar"
    ),
  { fallback: <Loader /> }
);
export const Book = Loadable(
  () =>
    import(
      /* webpackChunkName: "RestaurantBookPage" */ "pages/restaurant/book"
    ),
  { fallback: <Loader /> }
);
export const Waitlist = Loadable(
  () =>
    import(
      /* webpackChunkName: "RestaurantWaitlistPage" */ "pages/restaurant/waitlist"
    ),
  { fallback: <Loader /> }
);
export const WaitlistSidebar = Loadable(
  () =>
    import(
      /* webpackChunkName: "RestaurantWaitlistSidebarPage" */ "pages/restaurant/waitlist/Sidebar"
    ),
  { fallback: <Loader /> }
);
export const WaitlistDetails = Loadable(
  () =>
    import(
      /* webpackChunkName: "RestaurantWaitlistDetailsPage" */ "pages/restaurant/waitlist/details"
    ),
  { fallback: <Loader /> }
);
export const ImageCarousel = Loadable(
  () =>
    import(
      /* webpackChunkName: "RestaurantImageCarousel" */ "pages/restaurant/components/image-carousel"
    ),
  { fallback: <ImageCarouselLoader /> }
);
export const RestaurantInfo = Loadable(
  () =>
    import(
      /* webpackChunkName: "RestaurantInfo" */ "pages/restaurant/restaurant-info"
    ),
  { fallback: <MobileRestaurantInfoLoader /> }
);
export const OverviewSidebar = Loadable(
  () =>
    import(
      /* webpackChunkName: "RestaurantOverviewSidebar" */ "pages/restaurant/overview/Sidebar"
    ),
  { fallback: <Loader /> }
);
export const BookSidebar = Loadable(
  () =>
    import(
      /* webpackChunkName: "RestaurantBookSidebar" */ "pages/restaurant/book/Sidebar"
    ),
  { fallback: <Loader /> }
);
export const ReservationDetails = Loadable(
  () =>
    import(
      /* webpackChunkName: "RestaurantReservationDetailsPage" */ "pages/restaurant/book/reservation-details"
    ),
  { fallback: <Loader /> }
);
export const QGFooter = Loadable(
  () =>
    import(
      /* webpackChunkName: "RestaurantQGFooter" */ "components/Footer2/QGFooter"
    ),
  { fallback: <Loader /> }
);
export const Tabs = Loadable(
  () =>
    import(
      /* webpackChunkName: "RestaurantTabs" */ "pages/restaurant/components/tabs"
    ),
  { fallback: <TabsLoader /> }
);
export const AppBar = Loadable(
  () =>
    import(
      /* webpackChunkName: "RestaurantAppBar" */ "pages/restaurant/app-bar"
    ),
  { fallback: <AppBarLoader /> }
);
